"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Toggle = exports["default"] = /*#__PURE__*/function (_Component) {
  function Toggle() {
    var _this;
    (0, _classCallCheck2["default"])(this, Toggle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Toggle, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      on: false
    });
    (0, _defineProperty2["default"])(_this, "toggle", function (e) {
      if (e) {
        e.stopPropagation();
      }
      var on = _this.state.on;
      _this.setState({
        on: !on
      });
    });
    return _this;
  }
  (0, _inherits2["default"])(Toggle, _Component);
  return (0, _createClass2["default"])(Toggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var on = this.props.on;
      on ? this.toggle() : null;
    }
  }, {
    key: "render",
    value: function render() {
      var on = this.state.on;
      var children = this.props.children;
      return children({
        on: on,
        toggle: this.toggle
      });
    }
  }]);
}(_react.Component);
(0, _defineProperty2["default"])(Toggle, "propTypes", {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].func]).isRequired
});